/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_PhoneInputs */

const cs_sms_phone = /** @type {(inputs: Sms_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonní číslo`)
};

const en_sms_phone = /** @type {(inputs: Sms_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Sms_PhoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_phone = /** @type {((inputs?: Sms_PhoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_PhoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_phone(inputs)
	return cs_sms_phone(inputs)
});